import React from 'react';

import {CTAButtonFixed} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {FiveStarsEnum} from 'main/analytics/gaTagsEnum';
import {Loading} from 'presentation/components/Loading/Loading';
import {FooterActionsProps} from './types';

export function FooterActions({
	step,
	onBack,
	onNext,
	totalSteps,
	isSubmitting,
}: FooterActionsProps) {
	const {isMobile} = useMediaQueries();
	const primaryActionText = step === totalSteps ? 'Concluir' : 'Avançar';

	return (
		<CTAButtonFixed.Root
			sx={{bottom: 0}}
			flexDirection={isMobile ? 'column' : 'row'}
			justifyContent={isMobile ? 'center' : 'space-between'}>
			<CTAButtonFixed.Action
				sx={{order: isMobile ? 1 : 0}}
				size="large"
				variant="outlined"
				onClick={onBack}
				disabled={isSubmitting}
				data-tag-id={FiveStarsEnum.CLICK_VOLTAR_AVALIACAO}>
				Voltar
			</CTAButtonFixed.Action>
			<CTAButtonFixed.Action
				size="large"
				onClick={onNext}
				disabled={isSubmitting}
				endIcon={isSubmitting ? <Loading size={20} color="inherit" /> : null}
				data-tag-id={FiveStarsEnum.CLICK_AVANCAR_AVALIACAO}>
				{primaryActionText}
			</CTAButtonFixed.Action>
		</CTAButtonFixed.Root>
	);
}
